import { createStyles, makeStyles } from '@material-ui/core/styles';
export var useInputV1Styles = makeStyles(function (theme) {
    return createStyles({
        root: {
            marginBottom: theme.spacing(1),
        },
    });
});
